import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { HotelSegmentResponse } from '../../../../../../models/itinerary';
import { AppState } from '../../../../../../store/model';
import { getSegmentResponse, isSaviSelectIntl } from '../../../../../../store/reducers/itinerary/selectors';
import { HotelRoute as HotelRouteLab } from '../../../../../lab/Route/HotelRoute';
import { getASegmentDetailsForSaviSelectIntlHotel } from '../../../../../../store/reducers/itinerary/saviSelectIntlSelector';

interface OwnProps {
  optionId: string;
  segmentId: number;
}

interface StateProps {
  checkIn: Date;
  checkOut: Date;
}

interface HotelProps extends StateProps {}

const mapStateToProps = (state: AppState, { segmentId }: OwnProps) => {
  if(!isSaviSelectIntl(state)) {
    const { checkIn, checkOut } = getSegmentResponse(segmentId)(
      state,
    ) as HotelSegmentResponse;

    return {
      checkIn,
      checkOut,
    };
  }
  else {
    const targetedHotel = getASegmentDetailsForSaviSelectIntlHotel(segmentId)(state);
    const checkIn = targetedHotel!.checkInDateAndTime
    const checkOut =targetedHotel!.checkOutDateAndTime
    return {
      checkIn,
      checkOut,
    };
  }
};

const enhance = compose<HotelProps, OwnProps>(connect(mapStateToProps));

export const HotelRoute = enhance(HotelRouteLab);

HotelRoute.displayName = 'HotelRoute';
